const PIXEL_ID = '4033647100269664';
const FB_EVENTS_SRC = 'https://connect.facebook.net/en_US/fbevents.js';

type FbqFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: unknown;
  loaded?: boolean;
  version?: string;
};

declare global {
  interface Window {
    fbq?: FbqFunction;
    _fbq?: FbqFunction;
  }
}

let initialized = false;

function createQueue(): FbqFunction {
  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args);
    } else {
      fbq.queue.push(args);
    }
  } as FbqFunction;

  fbq.queue = [];
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.push = fbq;

  return fbq;
}

/**
 * Loads the Meta Pixel and fires the initial PageView.
 *
 * The script tag is appended to <head> (falling back to <html>) instead of being
 * inserted before an existing <script> element — bundled/iframed previews can have
 * no script tags in the document, which makes the official snippet's insertBefore fail.
 */
export function initMetaPixel() {
  if (initialized || typeof window === 'undefined' || typeof document === 'undefined') return;
  initialized = true;

  if (!window.fbq) {
    const fbq = createQueue();
    window.fbq = fbq;
    window._fbq = fbq;

    const script = document.createElement('script');
    script.async = true;
    script.src = FB_EVENTS_SRC;
    (document.head || document.documentElement).appendChild(script);
  }

  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
}

/**
 * Tracks a standard or custom Meta Pixel event. Queued if the script hasn't downloaded yet.
 */
export function trackMetaEvent(event: string, params?: Record<string, unknown>) {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', event, params);
}
